import React from 'react';
import { getInitials } from '../../../utility/string.utils';
import styles from './styles.module.scss';

interface AvatarProps {
  imageUrl?: string;
  name: string;
}

const Avatar: React.FC<AvatarProps> = ({ imageUrl, name }) => {
  const initials = getInitials(name);

  return imageUrl ? (
    <img
      src={imageUrl}
      alt={name}
      className={`rounded-circle ${styles.avatar}`}
    />
  ) : (
    <div
      className={`rounded-circle d-flex align-items-center justify-content-center text-white avatar ${styles.avatar}`}
    >
      {initials}
    </div>
  );
};

export default Avatar;
